let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("avCUM"), load("dBjkU"), load("gQSWJ"), load("c6MKV"), load("aZinD"), load("c0JsV")]).then(() => parcelRequire('cDSVd'));